import React, { createContext, useContext } from "react";
import {
  useBroadcastManager,
  BroadcastManagerProps,
} from "../../../hooks/useBroadcastManager";

export type BroadcastManagerContextType = ReturnType<
  typeof useBroadcastManager
>;

interface BroadcastManagerProviderProps extends BroadcastManagerProps {
  children: React.ReactNode;
}

const BroadcastManagerContext =
  createContext<BroadcastManagerContextType | null>(null);

export const BroadcastManagerProvider: React.FC<
  BroadcastManagerProviderProps
> = (props) => {
  const broadcastManager = useBroadcastManager(props);
  return (
    <BroadcastManagerContext.Provider value={broadcastManager}>
      {props.children}
    </BroadcastManagerContext.Provider>
  );
};

export const useBroadcastManagerContext = () => {
  const context = useContext(BroadcastManagerContext);
  if (!context) {
    throw new Error(
      "useBroadcastManagerContext must be used within a BroadcastManagerProvider"
    );
  }
  return context;
};
